<template>
	<div class="notice ">
		<div class="flex items-center justify-between pb-[6px] bB-03">
			<div class="flex items-center">
				<div @click="navClick(item,index)" v-for="(item,index) in navList" :key="index"
					:class="type==item.type?'active text-[#FF0000] font-bold':'text-[#1C1F21]'"
					class="navTitle cursor-pointer  relative text-[16px] mr-[30px]">
					{{item.title}}
				</div>
			</div>
			<div @click="markAllRead()"
				class="min-w-[90px] h-[34px] px-[10px] box-border cursor-pointer leading-[34px] text-center text-[#ffffff] rounded-[4px] bg-[#FF0000] ">
				{{langInfo.one_click_read}}
			</div>
		</div>
		<router-view></router-view>
	</div>
</template>

<script>
	export default {
		name: "notice",
		data() {
			return {
				type: 0,
				navList: [{
						title: '', //订单通知
						type: 1,
						path: '/personalCenter/notice/newSystem?type=1'
					},
					{
						title: '', //评论回复通知
						type: 2,
						path: '/personalCenter/notice/newSystem?type=2'
					},
					{
						title: '', //疑问回复通知
						type: 3,
						path: '/personalCenter/notice/newSystem?type=3'
					},
					{
						title: '', //课程更新
						type: 4,
						path: '/personalCenter/notice/newSystem?type=4'
					},
					{
						title: '', //促销活动
						type: 5,
						path: '/personalCenter/notice/newSystem?type=5'
					},
					{
						title: '', //系统公告
						type: 6,
						path: '/personalCenter/notice/newSystem?type=6'
					},
					{
						title: '', //站内信
						type: '0,7',
						path: '/personalCenter/notice/newSystem?type=0,7'
					}
				],
				langInfo: {}
			}
		},
		watch: {
			'$route'(to, from) {
				// 当路由变化时，这里的to和from包含了路由信息
				console.log("to.query.type212121===="); // 获取查询参数
				// 你可以在这里处理查询参数的变化
				console.log(to.path);
				this.type = to.query.type

			}
		},
		mounted() {
			if (this.$route.path == '/personalCenter/notice/otherInfo') {
				this.type = 2
			} else {
				if (this.$route.query.type) {
					this.type = this.$route.query.type
				}
			}

			this.langInfo = this.$store.getters['lang/getLangList']
			if (this.langInfo.length == 0) {
				this.getdict_data()
			} else {
				this.setNav()
			}

		},
		methods: {
			setNav() {
				this.navList[0].title = this.langInfo['Order Notice']
				this.navList[1].title = this.langInfo['Comment  Notice']
				this.navList[2].title = this.langInfo['Question Reply Notice']
				this.navList[3].title = this.langInfo['Course Update']
				this.navList[4].title = this.langInfo['Promotional activity']
				this.navList[5].title = this.langInfo['System Notice']
				this.navList[6].title = this.langInfo['Internal System']				


			},
			getdict_data() {
				this.$api.dict_data({}).then((res) => {
					console.log(res);
					const obj = {}
					res.data.forEach((item, index) => {
						obj[item.key] = item.value
					})
					this.langInfo = obj
					this.setNav()
					this.$store.dispatch('lang/setLangList', obj)
				}).catch((error) => {})
			},
			navClick(item, index) {
				if (item.path) {
					if (this.$route.fullPath == item.path) {
						// 如果相同则不进行导航
						return;
					}
					this.type = item.type
					this.$router.push(item.path); // 使用完整路径
				}
			},
			markAllRead() {
				this.$api.markAllRead({
					type: this.type,
				}).then((res) => {
					console.log(res);
				}).catch((error) => {
					this.$message({
						message: error.msg,
						type: 'warning'
					})
				})
			}
		}
	};
</script>

<style scoped>
	.navTitle.active::after {
		content: "";
		position: absolute;
		width: 100%;
		height: 4px;
		background-color: #FF0000;
		bottom: -12px;
		left: 50%;
		transform: translateX(-50%);

	}

	.navTitle:nth-last-child(1) {
		margin-right: 0;
	}
</style>